/* eslint-disable @typescript-eslint/no-empty-function */
import XDialog from '@/components/x-dialog/XDialog.vue'
import { BaseController } from './BaseController'

/**
 *表单
 * @export
 * @class EditForm
 */
export class Dialog extends BaseController {
  /**
   * 构造搜索表单
   * @param el 挂载节点
   * @param customContent 用户内容
   * @param title 对话框标题
   * @param footers 对话框底部按钮
   */
  constructor(
    el: Element,
    customContent: VueComponent,
    title?: string,
    width?: string,
    footers?: Footer[],
  ) {
    super(el, XDialog, {
      customContent,
      title,
      footers,
      width: width || '40%'
    })
  }

  /**
   * 打开对话框
   * @param data 加载数据的请求参数/初始表单值
   * @returns 
   */
  open(data?: any): Promise<boolean> {
    if(this.controller) {
      return this.controller.open(data)
    } else {
      return Promise.reject(false)
    }
  }

  /**
   * 关闭对话框
   * @returns 
   */
  close() {
    if(this.controller) {
      return this.controller.close()
    }
  }
}

